import {
    ChangeDetectionStrategy,
    Component,
    input,
} from "@angular/core";
import { UserBonusListDirective } from "@Front-end/seed/modules/user-bonuses";
import { LetDirective } from "@ngrx/component";

@Component({
    selector: "ls-bonus-amount",
    imports: [
        LetDirective,
        UserBonusListDirective,
    ],
    templateUrl: "./bonus-amount.component.html",
    styleUrl: "./bonus-amount.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        class: "bonus-amount",
    },
})
export class BonusAmountComponent {
    public isProfilePage = input.required<boolean>();
}
